import { FC } from 'react';

import Alert from 'components/Alert/Alert';

import { AlertType } from 'constants/enums';

import { useTranslation } from 'react-i18next';
import styles from './InterviewDeclined.module.scss';

const InterviewDeclined: FC = () => {
  const { t } = useTranslation()
  return (
    <>
      <h2 className={styles.title}>{t('sidebar.application.interview.declined.title')}</h2>
      <Alert
        type={AlertType.Error}
        message={t('sidebar.application.interview.declined.message')}
        className={styles.alert}
      />
    </>
  );
};

export default InterviewDeclined;
